export class ActiveAgencies {
  agencyId: string = ""
  agencyName: string = ""
}

export class B2BActiveBranches {
  branchId: string = "";
  branchName: string = "";
}

export class ActiveBranches {
  branchCode: string;
  branchName: string;
}

export class CustomerSaleOrder {
  customerCode: string
  customerName: string
}

export class ActiveCurrencies {

  currencyId: number = 0;
  currencyName: string = "";

}

export class ActiveLanguages {
  languageId: number = 0;
  name: string = "";

}

export class ActiveTimeZones {
  id: number = 0;
  //:
  value: string = "";
  //:
}
export class ActiveAirlines {
  airlineID: number = 0;
  airlineCode: string = "";
  airlinePrefixCode: string = "";
}
export class AirTicketActiveRights {
  ticketRightsId: number = 0;

  rightsName: string = "";

}

export class ActiveSuppliers {
  supplierId: string = "";
  name: string = "";
}
export class ActiveSupplierAccessCodes {
  supplierAccessCodeId: number = 0;

  accessCode: string = "";
}
export class ActiveSupplierTypes {

  supplierTypeId: string = "";
  name: string = "";

}

export class ActiveAgenciesTypes {

  agencyTypeId: number = 0;
  type: string = "";

}

export class Agency_Branches {
  code: string = "";
  name: string = "";
}
export class Supplier_OficeID {
  OfficeId: string
  supplierId: string
}

export class ParentUsers {
  labelName: string = "";
  fullname: string = "";
  userId: number = 0;

}

export class ActiveBenificaryAccount {
  accountName: string = "";
  accountNo: string = "";
}

export class ActiveDepositType {
  depositTypeId: number = 0;
  //{ get; set; }
  depositTypeName: string = "";
  //{ get; set; }
}
export class ActiveModeOfPayment {
  modeOfPaymentId: number = 0;
  //{ get; set; }
  modeOfPaymentName: string = "";
  //{ get; set; }
}
export class ManagerListForPayments {
  userId: number = 0;
  userName: string = "";
 }


export class ActivePassengerType {
  passengerTypeId: number = 0;
  //{ get; set; }
  typeName: string = "";
  //{ get; set; }
}
export class ActiveCountries {
  countryId: number = 0;
  //{ get; set; }
  countryName: string = "";
  //{ get; set; }
}
export class ActiveTripTypes {
  journeyTypeId: number = 0;
  //{ get; set; }
  journeyName: string = "";
  //{ get; set; }
}
export class ActiveAirportCity {
  airportCityId: number = 0;
  //;{ get; set; }
  iataCode: string = "";
  //{ get; set; }
}

export class AirportCityProperties {
  iatA_CODE: string = "";
}

export class ActiveCardTypes {
  cardTypeId: number = 0;
  cardTypeName: string = "";
}
export class ActiveAgencyGroups {
  groupId: string = "";
  name: string = "";
}
export class OfflineRequestTypes {
  requestTypeId: number = 0;

  requestTypeName: string = "";

}

export class ABName_ID {
  backSystemAgencyBranchName: string = "";
  agecnyBranchID: string = "";
}
export class BackSystemAll {
  backSystemBK_AgencyBranchID: number;
  backSystemAgencyBranchCodes: string = "";
}
export class BackSystemAllList {
  backSystemAgencyBranchName: string = ""
  agecnyBranchID: string = "";
  backSystemAll: BackSystemAll[] = []

}
export class BackSystemAgencyNames {
  backSystemAgencyBranchName: string = "";

}
